<template>
    <div class="success">
        <h1 class="title mb-5">Success!</h1>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "SuccessScreen"
}
</script>

<style lang="scss" scoped>

</style>